import { Input, Select, Table, Tag, Typography } from "antd";
import GlassPanel from "../../components/common/glassPanel";

const { Text } = Typography;

const catalogRows = [
  { key: "1", recordType: "Listing", ref: "LST-24018", owner: "Prime Motors", reviewState: "Pending", issues: 1, quality: "94%" },
  { key: "2", recordType: "Vehicle", ref: "VEH-11204", owner: "Karibu Autos", reviewState: "Rejected", issues: 3, quality: "88%" },
  { key: "3", recordType: "Auction", ref: "AUC-99215", owner: "MileOne Imports", reviewState: "Approved", issues: 0, quality: "97%" },
];

export default function WheelsCatalogScreen() {
  return (
    <div className="space-y-4 px-1 py-1">
      <GlassPanel
        eyebrow="Wheels"
        title="Catalog and Moderation"
        actions={
          <div className="flex flex-wrap gap-2">
            <Select
              defaultValue="all"
              options={[
                { value: "all", label: "All record types" },
                { value: "listing", label: "Listings" },
                { value: "vehicle", label: "Vehicles" },
                { value: "auction", label: "Auctions" },
              ]}
              style={{ width: 160 }}
            />
            <Select
              defaultValue="all"
              options={[
                { value: "all", label: "All review states" },
                { value: "pending", label: "Pending" },
                { value: "rejected", label: "Rejected" },
                { value: "approved", label: "Approved" },
              ]}
              style={{ width: 170 }}
            />
            <Input.Search placeholder="Search reference or dealer" style={{ width: 220 }} />
          </div>
        }
      >
        <Text type="secondary">
          Listings, vehicle records, and auction quality checks are Wheels-specific operational surfaces.
        </Text>
      </GlassPanel>

      <GlassPanel title="Review Matrix">
        <Table
          rowKey="key"
          size="small"
          pagination={{ pageSize: 10, showSizeChanger: false }}
          dataSource={catalogRows}
          columns={[
            { title: "Record Type", dataIndex: "recordType" },
            { title: "Reference", dataIndex: "ref" },
            { title: "Owner", dataIndex: "owner" },
            {
              title: "Review State",
              dataIndex: "reviewState",
              render: (value: string) => (
                <Tag color={value === "Approved" ? "success" : value === "Rejected" ? "error" : "processing"}>{value}</Tag>
              ),
            },
            { title: "Issues", dataIndex: "issues" },
            { title: "Quality Score", dataIndex: "quality" },
          ]}
        />
      </GlassPanel>
    </div>
  );
}
